/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
/* eslint-disable comma-dangle */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import ESRDark from "../assets/images/CaseStudy/ESRDarkBG.png";

const TestimonialSection = () => {
    return (
        <section className="w-full bg-[#0f171a] py-24 lg:py-16">
            <div className="max-w-4xl mx-auto px-6 text-center">
                <div className="mb-10 flex justify-center">
                    <img
                        src={ESRDark}
                        alt="ESR Logo"
                        className="h-12 w-auto bg-transparent"
                    />
                </div>

                <blockquote className="text-md md:text-xl lg:text-2xl text-white font-light italic leading-relaxed mb-10">
                    &quot; Nube iO provides ESR and our customers with a window into utilities performance and ongoing reporting requirements without the need for complex building management systems.&quot;
                </blockquote>

                <div className="space-y-1">
                    <p className="text-white font-bold text-lg">
                        Nick Morse
                    </p>
                    <p className="text-theme-gray/60 font-light text-md tracking-wide">
                        Head of Property Operations, ESR
                    </p>
                </div>

            </div>
        </section>
    );
};

export default TestimonialSection;
